// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Nkg7F","stars":"styles_stars__ReZYH","star_text":"styles_star_text__X5tto","review_stars_wrapper":"styles_review_stars_wrapper__B3_Ci"};